import { useContext } from "react";
import DrawerContext from "./DrawerContext";

const useDrawerContext = () => {
  return useContext(DrawerContext);
};

export default useDrawerContext;
